import { useParams } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { selectClientLens, selectLookerReports } from "redux/slices/clientLens";
import { useEffect, useState } from "react";
import { LookerEmbedItem } from "generated/graphql";
import BreadcrumbDropdownPicker, {
  BreadcrumbDropdownPickerOption,
} from "components/Breadcrumbs/BreadcrumbDropdownPicker";
import { AppRoutes } from "AppRoutes";

export const ReportBreadcrumb = () => {
  const clientLens = useAppSelector(selectClientLens);

  const { reportId } = useParams<{ lensId: string; reportId: string }>();
  const [activeReport, setActiveReport] = useState<LookerEmbedItem | null | undefined>(undefined);
  const reports = useAppSelector(selectLookerReports);

  useEffect(() => {
    const report =
      reports.embedItems.find((r) => r.id === reportId) ||
      reports.folders.flatMap((f) => f.embedItems).find((r) => r?.id === reportId);
    setActiveReport(report);
  }, [reportId, reports]);

  const folderedItems: BreadcrumbDropdownPickerOption[] = reports.folders.flatMap((f) => [
    ...(f.embedItems
      ? f.embedItems.map((r) => ({
          title: r.name,
          route: AppRoutes.lensReportsBuilder(clientLens.id, r.id),
          category: f.name,
          uniqueId: f.name,
        }))
      : []),
  ]);

  const rootItems: BreadcrumbDropdownPickerOption[] = reports.embedItems.map((r) => ({
    title: r.name,
    route: AppRoutes.lensReportsBuilder(clientLens.id, r.id),
    category: clientLens.name,
    uniqueId: r.name,
  }));

  const allItems: BreadcrumbDropdownPickerOption[] = [...folderedItems, ...rootItems];

  return (
    <BreadcrumbDropdownPicker
      pendoId="breadcrumb-report::report-picker"
      search={false}
      label={activeReport?.name || "..."}
      noResultsText={undefined}
      currentRoute={AppRoutes.lensReportsBuilder(clientLens.id, reportId)}
      options={allItems}
      PopoverSX={{
        ".options-container": {
          maxHeight: "none",
        },
      }}
    />
  );
};
